import React, { useEffect, useState, useRef } from 'react';
import { Card } from '@arco-design/web-react';
import { postChatModel } from '../../Api/api';

// 内容清洗函数
function cleanContent(str) {
  if (!str) return '';
  // 去除首尾空格、引号、大括号、破折号、点号、换行
  str = str.trim()
    .replace(/^["'“”‘’{}、.．·\-———\s]+|["'“”‘’{}、.．·\-———\s]+$/g, '')
    .replace(/^[\r\n]+|[\r\n]+$/g, '');
  // 连续多个换行替换为一个
  str = str.replace(/[\r\n]{2,}/g, '\n');
  // 去除内容中多余的点号、破折号等
  str = str.replace(/^[·•\-———]+/gm, '');
  // 去除内容中所有大括号和多余引号
  str = str.replace(/[{}"“”‘’]/g, '');
  return str;
}

export default function SummaryCards({ currentTask }) {
  const [serviceIntro, setServiceIntro] = useState('');
  const [targetCustomer, setTargetCustomer] = useState('');
  const [loading, setLoading] = useState(false);

  // 前端缓存，避免重复请求
  const cacheRef = useRef({});

  useEffect(() => {
    const keyword = currentTask?.keyword;
    
    if (!keyword) {
      setServiceIntro('');
      setTargetCustomer('');
      return;
    }

    // 1. 先查缓存
    if (cacheRef.current[keyword]) {
      setServiceIntro(cacheRef.current[keyword].service);
      setTargetCustomer(cacheRef.current[keyword].customer);
      return;
    }

    // 2. 请求AI接口
    async function fetchData() {
      setLoading(true);
      try {
        // 你已经在 modelService.js 里配置了 template 对应的 bot_id
        // 这里直接用 mode='template'，query 传 prompt
        const servicePrompt = `请用简洁流畅的中文介绍${keyword}的服务内容，100字以内。`;
        const customerPrompt = `请用简洁流畅的中文介绍${keyword}的目标客户群体，包括他们的基本特征、兴趣爱好和需求，100字以内。`;



        // 分别请求服务介绍和客户描述
        const resService = await postChatModel(servicePrompt, 'template');
        const resCustomer = await postChatModel(customerPrompt, 'template');



        let service = '';
        let customer = '';
        if (Array.isArray(resService.messages)) {
          const answerMsg = resService.messages.find(m => m.type === 'answer');
          service = answerMsg?.content || '';
          
        } else {
          
        }
        if (Array.isArray(resCustomer.messages)) {
          const answerMsg = resCustomer.messages.find(m => m.type === 'answer');
          customer = answerMsg?.content || '';
          
        } else {
          
        }
        // 内容清洗
        service = cleanContent(service);
        customer = cleanContent(customer);



        // 存入缓存
        cacheRef.current[keyword] = { service, customer };
        setServiceIntro(service);
        setTargetCustomer(customer);
      } catch (e) {

        setServiceIntro('');
        setTargetCustomer('');
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [currentTask?.keyword]);

  return (
    <div style={{ display: 'flex', width: '100%' }}>
      <div style={{ display: 'flex', flex: '0 0 60%', gap: 24, marginBottom: 30 }}>
        <div style={{ flex: 1 }}>
          <div style={{ marginBottom: 8, fontWeight: 190, fontSize: 14 }}>我的服务介绍</div>
          <Card style={{ background: '#f5f5f5', border: '1px solid #e5e6eb', minHeight: 80 }} bodyStyle={{ padding: 14, color: '#bdbdbd', fontSize: 14 }}>
            {loading ? '加载中...' : (serviceIntro || '暂无服务介绍')}
          </Card>
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ marginBottom: 8, fontWeight: 190, fontSize: 14 }}>我想要的客户</div>
          <Card style={{ background: '#f5f5f5', border: '1px solid #e5e6eb', minHeight: 80 }} bodyStyle={{ padding: 14, color: '#bdbdbd', fontSize: 14 }}>
            {loading ? '加载中...' : (targetCustomer || '暂无客户描述')}
          </Card>
        </div>
      </div>
      <div style={{ flex: '0 0 40%' }}></div>
    </div>
  );
}